import { TceSummaryBySituation } from 'data/usecases';
import { TceSummaryBySituationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlTceManagement } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeTceSummaryBySituation =
  (): TceSummaryBySituationUseCaseInterface =>
    new TceSummaryBySituation(makeApiUrlTceManagement(), makeAxiosHttpClient());
